module.exports = __webpack_public_path__ + "04_glasses_blue.710c202a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/04_glasses_blue.png
// module id = ElhN
// module chunks = 0